import React, { memo } from 'react';
import { Route, Switch } from 'react-router-dom';
import ROUTES from 'constants/routes';
import PageNotFound from 'containers/PageNotFound';
import Login from './Login';
import NewPassword from './NewPassword';
import ResetPassword from './ResetPassword';
import CheckEmail from './CheckEmail';

const Router = () => (
  <Switch>
    <Route
      exact
      path={ROUTES.LOGIN.BASE}
      component={Login}
    />
    <Route
      exact
      path={ROUTES.LOGIN.CHECK_EMAIL}
      component={CheckEmail}
    />
    <Route
      exact
      path={ROUTES.LOGIN.RESET_PASSWORD}
      component={ResetPassword}
    />
    <Route
      exact
      path={ROUTES.LOGIN.NEW_PASSWORD()}
      component={NewPassword}
    />
    <Route component={PageNotFound} />
  </Switch>
);

export default memo(Router);
